import React, { useMemo } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from '@mui/material/Autocomplete';
import { makeStyles } from 'tss-react/mui';
import { 
  getPhoneBookEntry,
  getPhoneBookEntryByName,
} from "../utils/common";
import { isPhoneLike, dialDigits } from "../utils/contacts";

const useStyles = makeStyles()((theme) => ({
  autocompleteInput: {
    fontSize: "16px",
    // Paint the background on the input itself so rounded inputs do not
    // show a square box behind them.
    "& .MuiOutlinedInput-root": {
      backgroundColor: theme.palette.primary.contrastText,
    },
  },
}));

const AutoCompleteSelect = (props) => {
    const { classes } = useStyles();
    const sortedOptions = useMemo(
      () => [...(props.options || [])].sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter)),
      [props.options]
    );
    const {
      placeholder,
      setValue,
      setViewValue,
      multiple,
      viewValue,
      onTextFieldKeyPress,
      phonebook,
      inputPlaceholder,
      size,
      hidePopupIcon,
      disableClearable,
      filterOptions,
      inputValue,
      onInputValueChange,
      disableGrouping,
    } = props;

    const onChangeCallback = (e, newValue, reason) => {
      if (typeof newValue === "object") {
        setValue(newValue)
      } else if (isPhoneLike(newValue)) {
        setValue(phonebook ? getPhoneBookEntry(phonebook, dialDigits(newValue)) : dialDigits(newValue))
      } else if (phonebook && newValue) {
        setValue(getPhoneBookEntryByName(phonebook, newValue) || null)
      } else {
        setValue(null)
      }
    }

    const onInputChangeCallback = (e, newValue) => {
      if (onInputValueChange) {
        onInputValueChange(newValue);
      }
      if (newValue === "" || isPhoneLike(newValue)) {
        setViewValue(newValue)
        if (phonebook && newValue !== "" ) {
          const entry = getPhoneBookEntry(phonebook, dialDigits(newValue))
          setValue(entry)
        }
      } else if (phonebook && newValue !== "") {
        const entry = getPhoneBookEntryByName(phonebook, newValue)
        setValue(entry || null)
      }
    }
  
    return (
      <Autocomplete
        multiple={multiple ? true : false}
        id="combo-box-demo"
        options={sortedOptions}
        groupBy={disableGrouping ? undefined : (option) => option.firstLetter}
        getOptionLabel={(option) =>
          typeof option === "string"
            ? option
            : `${option.firstName} ${option.lastName}`
        }
        value={viewValue}
        {...(inputValue !== undefined ? { inputValue } : {})}
        forcePopupIcon={hidePopupIcon ? false : true}
        disableClearable={disableClearable ? true : false}
        filterOptions={filterOptions}
        freeSolo={true}
        onChange={onChangeCallback}
        onInputChange={onInputChangeCallback}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              label={placeholder}
              placeholder={inputPlaceholder}
              size={size}
              variant="outlined"
              fullWidth
              className={classes.autocompleteInput}
              onKeyPress={(e) => {
                if (onTextFieldKeyPress) {
                  onTextFieldKeyPress(e);
                }
              }}
            />
          );
        }}
      />
    );
}

export default AutoCompleteSelect;